function ConsentToggle({ accepted, onChange }) {
  return (
    <button
      type="button"
      className="dataset-consent-toggle"
      aria-pressed={accepted}
      onClick={() => onChange(!accepted)}
    >
      <span className="dataset-consent-checkbox" aria-hidden="true">{accepted ? '✓' : ''}</span>
      <span>{accepted ? 'Acceptat en aquest dispositiu' : 'Accepto els termes d’ús i privacitat'}</span>
    </button>
  );
}

export default function DatasetConsent({ accepted, enabled, isPremium, language, onChange }) {
  if (!enabled || language !== 'ca' || isPremium) return null;

  if (accepted) {
    return (
      <section className="dataset-consent compact" aria-label="Consentiment del corpus català">
        <span className="dataset-consent-summary">Aportacions al corpus català activades en aquest dispositiu. <a href="/terms#contribucio-catala">Termes d’ús</a> · <a href="/privacy#us-audios-models">Privacitat</a></span>
        <ConsentToggle accepted onChange={onChange} />
      </section>
    );
  }

  return (
    <section className="dataset-consent" aria-label="Consentiment del corpus català">
      <p>Ajuda a millorar el reconeixement de veu en català. Si ho acceptes, conservarem aquest àudio per desenvolupar i avaluar models de veu a text. Personal autoritzat pot escoltar fragments per revisar-ne la qualitat.</p>
      <p>Consulta els <a href="/terms#contribucio-catala">Termes d’ús</a> i la <a href="/privacy#us-audios-models">Política de privacitat</a>.</p>
      <p className="dataset-consent-guarantees">En acceptar confirmes que ets major d’edat, que tens el permís informat de totes les persones que hi parlen i que l’àudio no inclou veus de menors, dades sensibles, informació confidencial ni secrets.</p>
      <ConsentToggle accepted={false} onChange={onChange} />
    </section>
  );
}
